import axios from 'axios';
import { apiPathUrl } from '../../utils/config';
import { clearPlatformSession, getPlatformToken } from './platformAuth';

export const PLATFORM_ENDPOINTS = {
  dashboard: '/admin/dashboard/',
  communicationSettings: '/admin/communication-settings/',
  companies: '/admin/companies/',
  subscriptions: '/admin/subscriptions/',
  payments: '/admin/payments/',
  stripeConfig: '/admin/stripe-config/',
  issues: '/admin/issues/',
  leaderboard: '/admin/sales-leaderboard/',
  companyImpersonate: (companyId) => `/admin/companies/${companyId}/impersonate/`,
  resendCompanyInvitation: (companyId) => `/admin/companies/${companyId}/resend-invitation/`,
  exitImpersonation: '/admin/impersonation/exit/',
};

const platformApi = axios.create({
  baseURL: apiPathUrl,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
});

platformApi.interceptors.request.use((config) => {
  const token = getPlatformToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});

platformApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== '/super-admin/login') {
      clearPlatformSession();
      window.location.assign('/super-admin/login');
    }
    const payload = error?.response?.data;
    if (payload && typeof payload === 'object') {
      return Promise.reject({ ...payload, status: error.response.status });
    }
    return Promise.reject({
      message: typeof payload === 'string' ? payload : error?.message,
      status: error?.response?.status,
    });
  }
);

export default platformApi;

